import React from 'react';
import { Adsense } from '@ctrl/react-adsense';
import useAdsenseScript from '../useAdsenseScript';

const AdsenseResult: React.FC = () => {
    useAdsenseScript();

    return (
        <Adsense
            client="ca-pub-7378767920525255"
            slot="9805501235"
            style={{ display: 'block', textAlign: 'center', minHeight: '50px', maxHeight: '300px' }}
            format="fluid"
            layout="in-article"
        />
    );
};

export default AdsenseResult;
